namespace TabAurous.Common {
    export interface Items {
        VoucherTypeId?: number;
        VoucherDate?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        PartyId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        Hallmark?: number;
        RefNo?: string;
        ItemTypeId?: number;
        ProductTypeId?: number;
        ProductId?: number;
        ProductCode?: string;
        ProductName?: string;
        AttributeId?: number;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        CalcOnId?: number;
        UnitRate?: number;
        UnitLabour?: number;
        UnitCost?: number;
        NetAmount?: number;
        Discount?: number;
        GrossAmount?: number;
        RefTransItemId?: number;
        RefTransTypeId?: number;
        RefTransId?: number;
        ImageName?: string;
        Remark?: string;
        SpecialRemark?: string;
        UserDescription?: string;
        AckStatus?: number;
        StockAllocation?: boolean;
        DeliveryDate?: string;
        CompanyId?: number;
        BagStatus?: string;
        WstPer?: number;
        WstWt?: number;
        Purity?: number;
        PureWeight?: number;
        BOMDetails?: ItemBOM[];
        LaborDetails?: ItemLabour[];
        Rate?: number;
        HSN?: string;
        TaxCode?: string;
        ServerDate?: string;
        Remarks?: string;
        Lab?: string;
        DiscountPer?: number;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        ProductTypeCode?: string;
        ItemType?: string;
        CategoryId?: number;
        CategoryCode?: string;
        SubCategoryId?: number;
        SubCategoryCode?: string;
        KaratId?: number;
        KaratName?: string;
        KaratCode?: string;
        MetalColorId?: number;
        MetalColorCode?: string;
        ProductSizeId?: number;
        ProductSizeCode?: string;
        StoneSizeId?: number;
        StoneSizeCode?: string;
        BrandId?: number;
        BrandCode?: string;
        CollectionId?: number;
        CollectionCode?: string;
        SuperTypeId?: number;
        SuperTypeCode?: string;
        ShapeId?: number;
        ShapeCode?: string;
        SieveId?: number;
        SieveCode?: string;
        GroupSieveId?: number;
        GroupSieveCode?: string;
        QualityId?: number;
        QualityCode?: string;
        StoneColorId?: number;
        StoneColorCode?: string;
        StampId?: number;
        StampCode?: string;
        MetalId?: number;
        MetalCode?: string;
        MetalName?: string;
        MF?: number;
        MFAmount?: number;
        StoneCutId?: number;
        StoneCutCode?: string;
        StonePolishId?: number;
        StonePolishCode?: string;
        StoneSymmetryId?: number;
        StoneSymmetryCode?: string;
        StoneFluorescenceId?: number;
        StoneFluorescenceCode?: string;
        StoneCuletId?: number;
        StoneCuletCode?: string;
        StoneGirdleId?: number;
        StoneGirdleCode?: string;
        StoneTable?: string;
        StoneDepth?: string;
    }
}
